export const TKeyDashboard = {
  DASHBOARD_START_CALLS_TITLE: "DASHBOARD_START_CALLS_TITLE",
  DASHBOARD_START_CALLS_CTA: "DASHBOARD_START_CALLS_CTA",
  DASHBOARD_START_AVATARS_TITLE: "DASHBOARD_START_AVATARS_TITLE",
  DASHBOARD_START_AVATARS_CTA: "DASHBOARD_START_AVATARS_CTA",
  DASHBOARD_START_PROSPECTS_TITLE: "DASHBOARD_START_PROSPECTS_TITLE",
  DASHBOARD_START_PROSPECTS_CTA: "DASHBOARD_START_PROSPECTS_CTA",
  DASHBOARD_START_MESSAGES_TITLE: "DASHBOARD_START_MESSAGES_TITLE",
  DASHBOARD_START_MESSAGES_CTA: "DASHBOARD_START_MESSAGES_CTA",
  DASHBOARD_PROJECT_TITLE: "DASHBOARD_PROJECT_TITLE",
  DASHBOARD_COUNTER_ANALYSED_CALLS: "DASHBOARD_COUNTER_ANALYSED_CALLS",
  DASHBOARD_TASKS_TITLE: "DASHBOARD_TASKS_TITLE",
  DASHBOARD_TASKS_EMPTY: "DASHBOARD_TASKS_EMPTY",
  DASHBOARD_TASK_ANALYSE_CALLS_TITLE: "DASHBOARD_TASK_ANALYSE_CALLS_TITLE",
  DASHBOARD_TASK_ANALYSE_CALLS_CTA: "DASHBOARD_TASK_ANALYSE_CALLS_CTA",
  DASHBOARD_TASK_ENRICH_AVATAR_TITLE: "DASHBOARD_TASK_ENRICH_AVATAR_TITLE",
  DASHBOARD_TASK_ENRICH_AVATAR_CTA: "DASHBOARD_TASK_ENRICH_AVATAR_CTA",
  DASHBOARD_TASK_DETAIL_CALLS: "DASHBOARD_TASK_DETAIL_CALLS",
  DASHBOARD_TASK_STALE_CRITERIA_TITLE: "DASHBOARD_TASK_STALE_CRITERIA_TITLE",
  DASHBOARD_TASK_STALE_CRITERIA_CTA: "DASHBOARD_TASK_STALE_CRITERIA_CTA",
  DASHBOARD_TASK_STALE_SEQUENCES_TITLE: "DASHBOARD_TASK_STALE_SEQUENCES_TITLE",
  DASHBOARD_TASK_STALE_SEQUENCES_CTA: "DASHBOARD_TASK_STALE_SEQUENCES_CTA",
  DASHBOARD_TASK_SCAN_IMPORTED_PROFILES_TITLE: "DASHBOARD_TASK_SCAN_IMPORTED_PROFILES_TITLE",
  DASHBOARD_TASK_SCAN_IMPORTED_PROFILES_CTA: "DASHBOARD_TASK_SCAN_IMPORTED_PROFILES_CTA",
  DASHBOARD_TASK_UNTOUCHED_PROSPECTS_TITLE: "DASHBOARD_TASK_UNTOUCHED_PROSPECTS_TITLE",
  DASHBOARD_TASK_UNTOUCHED_PROSPECTS_CTA: "DASHBOARD_TASK_UNTOUCHED_PROSPECTS_CTA",
  DASHBOARD_FUNNEL_RATE: "DASHBOARD_FUNNEL_RATE",
  DASHBOARD_MARKET_CALLS: "DASHBOARD_MARKET_CALLS",
  DASHBOARD_CALLS_RATE: "DASHBOARD_CALLS_RATE",
  DASHBOARD_PROSPECTS_FIT: "DASHBOARD_PROSPECTS_FIT",
  DASHBOARD_ACTIVATION_PROGRESS: "DASHBOARD_ACTIVATION_PROGRESS",
} as const;
